import React from 'react';
import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

interface LoaderProps {
	isLoading: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isLoading }) => {
	if (!isLoading) return null;

	return (
		<LoaderOverlay>
			<CircularProgress size={40} />
		</LoaderOverlay>
	);
};

export default Loader;
